import { Link, NavLink, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import { Menu, X, Heart } from "lucide-react";

const NAV = [
  { to: "/", label: "Home" },
  { to: "/sermons", label: "Sermons" },
  { to: "/live", label: "Live" },
  { to: "/about", label: "About" },
  { to: "/give", label: "Give" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const [scrolledState, setScrolled] = useState(false);
  const loc = useLocation();
  // Always use the light/readable header style — the new branded hero has a light sky background
  const scrolled = true;

  useEffect(() => { setOpen(false); }, [loc.pathname]);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-[#FAFAF8]/85 backdrop-blur-xl border-b border-[#2A2E2C]/5" : "bg-transparent"
      }`}
    >
      <div className="ccn-container flex items-center justify-between h-20">
        <Link to="/" data-testid="logo-link" className="flex items-center gap-3 group">
          <img
            src="https://customer-assets.emergentagent.com/job_covenant-ministry/artifacts/fy3ha3jd_Christian%20Covenant%20Round%20LOGO.png"
            alt="Christian Covenant Network logo"
            data-testid="site-logo"
            className="w-12 h-12 rounded-full object-cover shadow-md"
          />
          <div className="leading-tight">
            <div className={`font-heading text-xl ${scrolled ? 'text-[#1E1E1E]' : 'text-white'}`}>Christian Covenant</div>
            <div className={`text-[10px] tracking-[0.3em] uppercase font-bold ${scrolled ? 'text-[#738C7A]' : 'text-[#DDA754]'}`}>Network</div>
          </div>
        </Link>

        <nav className="hidden md:flex items-center gap-1">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.to === "/"}
              data-testid={`nav-${n.label.toLowerCase()}`}
              className={({ isActive }) =>
                `px-4 py-2 text-sm font-medium rounded-full transition-colors ${
                  isActive
                    ? (scrolled ? "text-[#C8664D]" : "text-[#DDA754]")
                    : (scrolled ? "text-[#1E1E1E] hover:text-[#C8664D]" : "text-white/90 hover:text-[#DDA754]")
                }`
              }
            >
              {n.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <Link to="/give" data-testid="header-give-btn" className="ccn-btn-primary text-sm py-2.5 px-5">
            <Heart className="w-4 h-4" /> Give
          </Link>
        </div>

        <button
          data-testid="mobile-menu-toggle"
          className={`md:hidden p-2 rounded-full ${scrolled ? 'text-[#1E1E1E]' : 'text-white'}`}
          onClick={() => setOpen((s) => !s)}
          aria-label="menu"
        >
          {open ? <X /> : <Menu />}
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-[#FAFAF8] border-t border-[#2A2E2C]/5">
          <div className="ccn-container py-4 flex flex-col gap-1">
            {NAV.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                end={n.to === "/"}
                data-testid={`mobile-nav-${n.label.toLowerCase()}`}
                className={({ isActive }) =>
                  `px-4 py-3 rounded-xl font-medium ${
                    isActive ? "bg-[#F2EBE5] text-[#C8664D]" : "text-[#1E1E1E]"
                  }`
                }
              >
                {n.label}
              </NavLink>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}
